import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NgbDate, NgbCalendar} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { formatDate, formatJustDate } from '../../../../../core/_base/util/date.util';

@Component({
  selector: 'date-range',
  templateUrl: './date-range.component.html',
  styleUrls: [
      './date-range.component.scss'
  ]
})
export class DateRangeComponent implements OnInit, OnDestroy{

  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate;
  toDate: NgbDate | null = null;
  @Input() form = null;
  @Input() startControlName = null;
  @Input() endControlName = null;

  private subscriptions: Subscription[] = [];

  constructor(calendar: NgbCalendar) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  ngOnInit(){
    this.subscriptions.push(
      this.form.controls[this.startControlName].valueChanges.subscribe(value=>{
        const currentDateStr = formatJustDate(new Date(this.fromDate.year, this.fromDate.month-1, this.fromDate.day));
        if(value!=currentDateStr){
          this.fromDate = this.getNgbDateFromForm(this.startControlName);
          console.log("NEW FROM DATE BY CHANGE IN FORM");
          console.dir(this.fromDate);
        }
      })
    );

    this.subscriptions.push(
      this.form.controls[this.endControlName].valueChanges.subscribe(value=>{
        const currentDateStr = formatJustDate(new Date(this.toDate.year, this.toDate.month-1, this.toDate.day));
        if(value!=currentDateStr){
          this.toDate = this.getNgbDateFromForm(this.endControlName);
          console.log("NEW TO DATE BY CHANGE IN FORM");
          console.dir(this.toDate);
        }
      })
    );
  }

  getNgbDateFromForm(controlName){
    const value = this.form.controls[controlName].value;
    const splitedDateStr = value.split('-');
    console.dir(splitedDateStr)
    const year = Number(splitedDateStr[0]);
    const month = Number(splitedDateStr[1]);
    const day = Number(splitedDateStr[2].split('T')[0]);
    return new NgbDate(year, month, day);
  }

  ngOnDestroy(): void {
      this.subscriptions.forEach(sub=>sub.unsubscribe());
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;      
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }

    if(this.form){
        if(this.fromDate)this.form.controls[this.startControlName].patchValue(formatJustDate(new Date(this.fromDate.year, this.fromDate.month-1, this.fromDate.day)))
        if(this.toDate)this.form.controls[this.endControlName].patchValue(formatJustDate(new Date(this.toDate.year, this.toDate.month-1, this.toDate.day)))
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }
}